import { IUser } from "@interfaces";

export interface IEmail {
  id: string;
  subject: string;
  sender: IUser;
  participants: IUser[];
  internal_date: string;
  is_latest_email_in_thread?: boolean;
}

interface IEmailData {
  total_time_spent_in_minutes: number;
  emails: IEmail[];
}

interface IEmailResponse {
  page_no: number;
  total: number;
  data: IEmailData;
}

export interface IEmaiAPIlData {
  error?: string;
  response?: IEmailResponse;
}

export enum ParticipantType {
  SENDER = "sender",
  TO = "to",
  CC = "cc"
}

export interface IEmailSummary {
  id: string;
  subject: string;
  summary: string;
  next_steps: string;
  products_mentioned: string | null;
  internal_date: string;
}

export interface IEmailBody {
  id: string;
  subject: string;
  decrypted_body: string;
  body_content_type: string | null;
  internal_date: string;
}

export interface IEmailSummaryResponse {
  error: string | null;
  response: IEmailSummary;
}

export interface IEmailBodyResponse {
  error: string | null;
  response: IEmailBody;
}
